import styles from "./index.module.less";
import { getAllMusicFolders, getCollectMusic, getMusicList } from "@/services/music";
import React, { Fragment, useEffect, useState, useRef } from "react";
import fileIcon from "@/assets/create-space/file_img-min.png";
import { Checkbox, Image, Message, ModalProps, Spin, Empty } from "@arco-design/web-react";
import QuickStore from "@/stores/quickCutStore";
import useCoverAndBg from "@/useStore/mixCutDetail/useCoverAndBg";
import clearImg from "@/assets/create-space/script-clear.png";
import { observer } from "mobx-react";
import MusicCard from "../MusicCard/MusicCard";
import MusicPlayer from "@/pages/VideoClips/QuickCut/BgConfig/BgMusicConfig/BgMusicTabs/BgMusicContainer/MusicPlayer/MusicPlayer";
type Props = {
  selectAll: boolean;
  keyWord: string;
  isUserAction?: React.MutableRefObject<boolean>;
  emitIsUserAction: (value: boolean) => void;
};
const CustomNewMusic = observer((props: Props) => {
  const { selectAll, keyWord, isUserAction, emitIsUserAction } = props;
  const [fileLoading, setFileLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [fileId, setFileId] = useState(0);
  const [fileName, setFileName] = useState("");
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const { bgAudio } = useCoverAndBg();
  const { background } = QuickStore.quickcutData.settings;
  const [checkedIds, setCheckedIds] = useState<number[]>(background.musics?.map((item) => item.id) || []);
  const [currentId, setCurrentId] = useState<number>(null);
  const loadMoreRef = useRef(null);
  const [imgPage, setImgPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [baseUrl, setBaseUrl] = useState("");
  const [currentMusic, setCurrentMusic] = useState<{
    src: string;
    title: string;
    isPlay: boolean;
    duration: number;
  }>(null);
  const [pagination, setPagination] = useState({
    page: 1,
    page_size: 30,
  });
  useEffect(() => {
    setFileLoading(true);
    getAllMusicFolders({
      page: 1,
      page_size: 999,
    })
      .then((res) => {
        setFileLoading(false);
        setFileList(res?.items || []);
      })
      .finally(() => {
        setFileLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!isUserAction.current) return;
    if (tableData?.length > 0) {
      if (selectAll) {
        // 全选逻辑
        const newSelectedMusics = [...background.musics];
        const newCheckedIds = [...checkedIds];

        tableData.forEach((item) => {
          if (!newCheckedIds.includes(item.id)) {
            newSelectedMusics.push({
              ...item,
              duration: (item.music_type === 2 || item.music_type === 1) ? item.duration : item.duration * 1000,
              url: item.music_type === 2 ? baseUrl + item.file_url : item.play_info?.play_url || "",
            });
            newCheckedIds.push(item.id);
          }
        });

        background.musics = newSelectedMusics;
        setCheckedIds(newCheckedIds);
        emitIsUserAction(false);
      } else {
        const currentPageIds = tableData.map((item) => item.id);
        const newMusics = background.musics.filter((music) => !currentPageIds.includes(music.id));
        background.musics = newMusics;
        setCheckedIds((prev) => prev.filter((id) => !currentPageIds.includes(id)));
        emitIsUserAction(false);
      }
    }
  }, [selectAll, tableData]);

  const getList = async (page: number, isAppend: boolean) => {
    setLoading(true);
    const res = await getMusicList({
      page: page,
      page_size: pagination.page_size,
      id: fileId,
      keyword: keyWord,
      order_by: "created_at",
      order_type: "desc",
    });
    setTableData((prev) => (isAppend ? [...prev, ...(res.items || [])] : res.items || []));
    setHasMore(res.items.length === 30);
    setLoading(false);
    setBaseUrl(res.base_url);
  };
  useEffect(() => {
    getList(pagination.page, false);
  }, [fileId, pagination, keyWord]);

  useEffect(() => {
    setCheckedIds((background.musics || []).map((item) => item.id));
  }, [background.musics]);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loading && hasMore) {
          const nextPage = imgPage + 1;
          setImgPage(nextPage);
          getList(nextPage, true);
        }
      },
      { root: null, rootMargin: "0px", threshold: 0.1 }
    );
    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }
    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [loading, hasMore, imgPage]);

  const handleCheckMusic = (result: boolean, id: number) => {
    if (result) {
      if (background.musics?.length === 200) {
        Message.warning("最多选择200首音乐");
        return;
      }
      // 添加音乐
      const item = (tableData as any[]).find((item) => Number(item.id) === Number(id));
      if (item) {
        background.musics = [...background.musics, { ...item, duration: (item.music_type === 2 || item.music_type === 1) ? item.duration : item.duration * 1000, url: (item.music_type === 2 || item.music_type === 1) ? baseUrl + item.file_url : item.play_info?.play_url || "" }];
        setCheckedIds([...checkedIds, id]);
      }
    } else {
      // 移除音乐
      const index = background.musics.findIndex((item) => Number(item.id) === Number(id));
      if (index !== -1) {
        const newMusics = [...background.musics];
        newMusics.splice(index, 1);
        background.musics = newMusics;
        setCheckedIds(checkedIds.filter((checkedId) => checkedId !== id));
      }
    }
  };

  const getIds = () => {
    if (background.musics?.length > 0) {
      return background.musics.map((item) => item.id);
    }
    return [];
  };

  // 获取当前文件夹下面的音乐
  const getCountData = async (count: number, fileId: number) => {
    const res = await getMusicList({
      page: 1,
      page_size: count,
      id: fileId,
      keyword: keyWord,
      order_by: "created_at",
      order_type: "desc",
    });
    const data = res?.items || [];
    // 处理新数据，添加url字段
    const newData = data.map((item) => ({
      ...item,
      url: item.music_type === 2 ? baseUrl + item.file_url : item.play_info?.play_url || "",
    }));

    // 创建现有音乐ID的Set用于去重
    const existingIds = new Set(background.musics.map((music) => music.id));

    // 过滤掉已存在的音乐项
    const uniqueNewData = newData.filter((item) => !existingIds.has(item.id));

    // 合并并去重后的数据
    background.musics = [...background.musics, ...uniqueNewData];
    setCheckedIds([...checkedIds, ...uniqueNewData.map((item) => item.id)]);
    background.custom_file.push(fileId);
  };

  const processFolderSelection = async () => {
    // 如果不是用户操作，直接返回
    if (!isUserAction.current) return;

    if (fileList?.length) {
      if (selectAll && !fileId) {
        // 用户手动触发的全选
        const fileData = fileList.filter((item) => item.count > 0);
        let currentMusicCount = background.musics.length;

        for (const folder of fileData) {
          try {
            // 如果已经达到200首，停止处理
            if (currentMusicCount >= 200) break;

            // 计算当前文件夹可以添加的最大数量
            const remainingSpace = 200 - currentMusicCount;
            const pageSize = Math.min(folder.count, remainingSpace);

            const res = await getMusicList({
              page: 1,
              page_size: pageSize,
              id: folder.id,
              keyword: keyWord,
              order_by: "created_at",
              order_type: "desc",
            });

            const newMusics = res?.items || [];
            const existingIds = new Set(background.musics.map((m) => m.id));
            const uniqueNewMusics = newMusics.filter((music) => !existingIds.has(music.id));

            if (uniqueNewMusics.length === 0) continue;

            // 更新状态
            background.musics = [...background.musics, ...uniqueNewMusics];
            currentMusicCount += uniqueNewMusics.length;
            setCheckedIds((prev) => [...new Set([...prev, ...uniqueNewMusics.map((m) => m.id)])]);

            // 添加到已选文件夹列表
            if (!background.custom_file.includes(folder.id)) {
              background.custom_file.push(folder.id);
            }

            // 如果已经达到200首，停止处理
            if (currentMusicCount >= 200) {
              Message.warning("已达到200首音乐上限");
              break;
            }
          } catch (error) {
            console.error(`获取文件夹 ${folder.name} 的音乐失败:`, error);
          }
        }
      } else if (!selectAll && background?.custom_file?.length > 0) {
        // 用户手动取消全选
        const musicIdsToRemove = new Set<number>();

        await Promise.all(
          background.custom_file.map(async (folderId) => {
            try {
              const folder = fileList.find((f) => f.id === folderId);
              if (!folder) return;

              const res = await getMusicList({
                page: 1,
                page_size: folder.count,
                id: folder.id,
                keyword: keyWord,
                order_by: "created_at",
                order_type: "desc",
              });

              (res?.items || []).forEach((item) => musicIdsToRemove.add(item.id));
            } catch (error) {
              console.error(`获取文件夹 ${folderId} 的音乐失败:`, error);
            }
          })
        );

        if (musicIdsToRemove.size > 0) {
          background.musics = background.musics.filter((music) => !musicIdsToRemove.has(music.id));
          setCheckedIds((prev) => prev.filter((id) => !musicIdsToRemove.has(id)));
        }

        // 清空已选文件夹
        background.custom_file = [];
      }

      // 重置用户操作标志
      emitIsUserAction(false);
    }
  };

  // 在useEffect中使用
  useEffect(() => {
    processFolderSelection();
  }, [selectAll, fileList, keyWord]);
  return (
    <div className={styles["cus-main"]} style={{ flex: 1 }}>
      {!fileId && (
        <Spin style={{ width: "100%" }} loading={fileLoading}>
          <div className={`${styles["custom-box"]} custom-style-custom-box`}>
            {fileList?.length > 0 &&
              fileList.map((item) => {
                return (
                  <>
                    {item?.count > 0 && (
                      <div
                        onClick={() => {
                          setFileId(item.id);
                          setFileName(item.name);
                        }}
                        className={styles["file-item"]}
                        key={item.id}
                      >
                        <Checkbox
                          checked={background?.custom_file?.includes(item.id)}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          className={styles["file-check"]}
                          onChange={async (e) => {
                            if (e) {
                              if (item?.count > 0) {
                                if (background.musics.length === 200) {
                                  Message.warning("音乐数量不能超过200");
                                  return;
                                }
                                getCountData(200 - background.musics.length, item.id);
                              }
                            } else {
                              // 获取当前文件夹下的音乐ID
                              const res = await getMusicList({
                                page: 1,
                                page_size: item?.count || 0, // 获取该文件夹下的所有音乐
                                keyword: "",
                                id: item.id,
                                order_by: "created_at",
                                order_type: "desc",
                              });

                              // 获取这些音乐的ID
                              const musicIds = res?.items?.map((music) => music.id) || [];

                              // 从background.musics中移除这些音乐
                              background.musics = background.musics.filter((music) => !musicIds.includes(music.id));
                              // 同时更新checkedIds状态
                              setCheckedIds((prev) => prev.filter((id) => !musicIds.includes(id)));
                              background.custom_file = background.custom_file.filter((id) => id !== item.id);
                            }
                          }}
                        ></Checkbox>
                        <img className={styles["img"]} src={fileIcon} alt="" />
                        <div
                          className={styles["info"]}
                          style={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {item.name}
                        </div>
                        <div className={styles["file-num"]}>数量：{item?.count || 0}</div>
                      </div>
                    )}
                  </>
                );
              })}
          </div>
        </Spin>
      )}
      {
        !fileId && !(fileList || []).every(item => item?.count) && <div className={styles["empty"]}>
              <img src={clearImg} alt=""/>
              <p>暂无数据</p>
          </div>
      }
      {fileId ? (
        <div className={styles["cus-bread"]}>
          <span
            style={{color: "#333333", cursor: "pointer" }}
            onClick={() => {
              setFileId(0);
              setTableData([]);
              setPagination({
                page: 1,
                page_size: 30,
              });
              setImgPage(1);
              setHasMore(true);
              setFileName("");
            }}
          >
            自定义
          </span>{" "}
          / <span>{fileName}</span>
        </div>
      ) : (
        <></>
      )}
      {fileId && tableData?.length > 0 ? (
        <div className={`${styles["music-card-wrapper"]} custom-style-card-wrapper`}>
          {tableData?.length > 0 &&
            tableData.map((item, index) => (
              <Fragment key={item.name + item.id}>
                <MusicCard
                  showCollect={false}
                  handleCheckMusic={(e) => {
                    handleCheckMusic(e, item.id);
                  }}
                  currentId={currentId}
                  handleCancelCollectBtnClick={() => {
                    // todo
                  }}
                  hanldeCollectBtnClick={() => {
                    // todo
                  }}
                  onClick={() => {
                    setCurrentMusic({
                      title: item.name,
                      src: item.music_type === 2 ? baseUrl + item?.file_url : item?.play_info?.play_url,
                      duration: item.duration / 1000,
                      isPlay: true,
                    });
                    setCurrentId(item.id);
                  }}
                  handleCheckStateChange={(e) => {
                    handleCheckMusic(e, item.id);
                  }}
                  style={{
                    width: "calc(50% - 10px)",
                    marginRight: 9,
                    marginBottom: 9,
                    position: "sticky",
                  }}
                  checkState={getIds().includes(item.id)}
                  data={item}
                />
              </Fragment>
            ))}
          <div ref={loadMoreRef} style={{ height: 1 }} />
        </div>
      ) : (
        <></>
      )}
      {fileId && tableData?.length === 0 && !loading ? (
        <div className={styles["empty"]}>
          <img src={clearImg} alt="" />
          <p>暂无数据</p>
        </div>
      ) : (
        <></>
      )}
      {fileId && loading ? <Spin className={styles["empty"]}></Spin> : <></>}
      {currentMusic?.isPlay && (
        <MusicPlayer
          handleCloseBtnClick={() => {
            setCurrentMusic(null);
            setCurrentId(null);
          }}
          style={{ position: "absolute", top: 0, right: 0, left: 0, width: "calc(100% - 70px)" }}
          duration={currentMusic.duration}
          src={currentMusic.src}
          title={currentMusic.title}
        />
      )}
    </div>
  );
});
export default CustomNewMusic;
